import { Grid } from '@mui/material'
import React from 'react'
import RenderKPIs from './KPI'
import RenderValues from './Values'
interface RenderStatCardsProps {
  activeContractValue: number
  activeMRR: number
  mrrAtRisk30d: number
  openTasksCount: number
  dealsEndingSoonCount: number
  dealsWonCount: number
  contractsSentCount: number
  activeProductRevenue: number
  isLoading?: boolean
}
const RenderStatCards = ({
  activeContractValue,
  activeMRR,
  mrrAtRisk30d,
  openTasksCount,
  dealsEndingSoonCount,
  dealsWonCount,
  contractsSentCount,
  activeProductRevenue,
  isLoading = false,
}: RenderStatCardsProps) => {
  return (
    <Grid container spacing={2}>
      <RenderKPIs
        openTasksCount={openTasksCount}
        dealsEndingSoonCount={dealsEndingSoonCount}
        contractsSentCount={contractsSentCount}
        dealsWonCount={dealsWonCount}
        isLoading={isLoading}
      />
      <RenderValues
        activeContractValue={activeContractValue}
        activeMRR={activeMRR}
        mrrAtRisk30d={mrrAtRisk30d}
        activeProductRevenue={activeProductRevenue}
        isLoading={isLoading}
      />
    </Grid>
  )
}

export default RenderStatCards
